// extracted by mini-css-extract-plugin
export default {"button":"OuVHStdXpF_gcLHk3CwB","arrow":"Kx5HhkTJZDc9s14fTmjL","left":"zrjLzm0mW6h5SSu2jKLF","right":"mEqvr0qsR3pHI5PiKcHl"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"button\":\"OuVHStdXpF_gcLHk3CwB\",\"arrow\":\"Kx5HhkTJZDc9s14fTmjL\",\"left\":\"zrjLzm0mW6h5SSu2jKLF\",\"right\":\"mEqvr0qsR3pHI5PiKcHl\"}";
        // 1793273560042
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  